module.exports = __webpack_public_path__ + "assets/img/manuel.3ec0b4d9.jpg";